import { Link } from "react-router-dom";
import { useUser } from "../contexts/UserContext";
import { useTheme } from "../contexts/ThemeContext";
import WorkShell from "../components/AppPage";
export default function Settings() {
  const { currentUser, openLogoutModal } = useUser();
  const { theme, setTheme, isDark } = useTheme();
  return (
    <WorkShell title="Settings">
      <section className="zy-card mb-[18px] rounded-[20px] border border-slate-200 bg-white p-[22px] dark:border-[#363e46] dark:bg-[#23272c] [&_h2]:mb-3 [&_h2]:text-[19px] [&_h2]:font-bold [&_h3]:mb-2 [&_h3]:text-[17px] [&_h3]:font-bold">
        <h2>Account</h2>
        <Link
          className="zy-settings-row flex w-full justify-between gap-4 border-b border-slate-200 py-[15px] text-left dark:border-[#363e46]"
          to="/edit-profile"
        >
          Edit profile <span>→</span>
        </Link>
        <Link
          className="zy-settings-row flex w-full justify-between gap-4 border-b border-slate-200 py-[15px] text-left dark:border-[#363e46]"
          to="/change-password"
        >
          Change password <span>→</span>
        </Link>
        <Link
          className="zy-settings-row flex w-full justify-between gap-4 border-b border-slate-200 py-[15px] text-left dark:border-[#363e46]"
          to="/notifications"
        >
          Notifications <span>→</span>
        </Link>
      </section>
      <section className="zy-card mb-[18px] rounded-[20px] border border-slate-200 bg-white p-[22px] dark:border-[#363e46] dark:bg-[#23272c] [&_h2]:mb-3 [&_h2]:text-[19px] [&_h2]:font-bold [&_h3]:mb-2 [&_h3]:text-[17px] [&_h3]:font-bold">
        <h2>Payments</h2>
        <Link
          className="zy-settings-row flex w-full justify-between gap-4 border-b border-slate-200 py-[15px] text-left dark:border-[#363e46]"
          to="/bank-payouts"
        >
          Bank & Payouts{" "}
          <span>
            {currentUser?.sellerCanReceivePayments ? "Ready" : "Set up"} →
          </span>
        </Link>
        <Link
          className="zy-settings-row flex w-full justify-between gap-4 border-b border-slate-200 py-[15px] text-left dark:border-[#363e46]"
          to="/funds"
        >
          Your funds <span>→</span>
        </Link>
        <Link
          className="zy-settings-row flex w-full justify-between gap-4 border-b border-slate-200 py-[15px] text-left dark:border-[#363e46]"
          to="/subscription-plan"
        >
          Manage subscription <span>→</span>
        </Link>
      </section>
      <section className="zy-card mb-[18px] rounded-[20px] border border-slate-200 bg-white p-[22px] dark:border-[#363e46] dark:bg-[#23272c] [&_h2]:mb-3 [&_h2]:text-[19px] [&_h2]:font-bold [&_h3]:mb-2 [&_h3]:text-[17px] [&_h3]:font-bold">
        <h2>Appearance</h2>
        <label className="zy-settings-row flex w-full justify-between gap-4 border-b border-slate-200 py-[15px] text-left dark:border-[#363e46]">
          Match system preferences
          <input
            type="checkbox"
            checked={theme === "system"}
            onChange={(e) =>
              setTheme(e.target.checked ? "system" : isDark ? "dark" : "light")
            }
          />
        </label>
        <label className="zy-settings-row flex w-full justify-between gap-4 border-b border-slate-200 py-[15px] text-left dark:border-[#363e46]">
          Dark mode
          <input
            type="checkbox"
            disabled={theme === "system"}
            checked={isDark}
            onChange={(e) => setTheme(e.target.checked ? "dark" : "light")}
          />
        </label>
      </section>
      {currentUser?.isAdmin && (
        <section className="zy-card mb-[18px] rounded-[20px] border border-slate-200 bg-white p-[22px] dark:border-[#363e46] dark:bg-[#23272c] [&_h2]:mb-3 [&_h2]:text-[19px] [&_h2]:font-bold [&_h3]:mb-2 [&_h3]:text-[17px] [&_h3]:font-bold">
          <h2>Admin</h2>
          <Link
            className="zy-settings-row flex w-full justify-between gap-4 border-b border-slate-200 py-[15px] text-left dark:border-[#363e46]"
            to="/admin/approvals"
          >
            Job approvals →
          </Link>
          <Link
            className="zy-settings-row flex w-full justify-between gap-4 border-b border-slate-200 py-[15px] text-left dark:border-[#363e46]"
            to="/create-challenge"
          >
            Create challenge →
          </Link>
        </section>
      )}
      <section className="zy-card mb-[18px] rounded-[20px] border border-slate-200 bg-white p-[22px] dark:border-[#363e46] dark:bg-[#23272c] [&_h2]:mb-3 [&_h2]:text-[19px] [&_h2]:font-bold [&_h3]:mb-2 [&_h3]:text-[17px] [&_h3]:font-bold">
        <h2>Support & About</h2>
        <a
          className="zy-settings-row flex w-full justify-between gap-4 border-b border-slate-200 py-[15px] text-left dark:border-[#363e46]"
          href="mailto:info@capecodes.com"
        >
          Contact support →
        </a>
        <a
          className="zy-settings-row flex w-full justify-between gap-4 border-b border-slate-200 py-[15px] text-left dark:border-[#363e46]"
          href="https://app.formbricks.com/s/cmiixxcfr7j8bad01ahna3frl"
          target="_blank"
          rel="noreferrer"
        >
          Zylen feedback →
        </a>
        <Link
          className="zy-settings-row flex w-full justify-between gap-4 border-b border-slate-200 py-[15px] text-left dark:border-[#363e46]"
          to="/terms-of-service"
        >
          Terms of service →
        </Link>
        <Link
          className="zy-settings-row flex w-full justify-between gap-4 border-b border-slate-200 py-[15px] text-left dark:border-[#363e46]"
          to="/privacy-policy"
        >
          Privacy policy →
        </Link>
        <button
          className="zy-settings-row flex w-full justify-between gap-4 border-b border-slate-200 py-[15px] text-left dark:border-[#363e46]"
          onClick={openLogoutModal}
        >
          Log out →
        </button>
      </section>
      <section className="zy-card mb-[18px] rounded-[20px] border bg-white p-[22px] dark:border-[#363e46] dark:bg-[#23272c] [&_h2]:mb-3 [&_h2]:text-[19px] [&_h2]:font-bold [&_h3]:mb-2 [&_h3]:text-[17px] [&_h3]:font-bold border-red-300">
        <h2 className="text-red-600">Danger zone</h2>
        <p className="zy-muted text-sm text-slate-500 dark:text-[#a4b0bc] mb-4">
          Permanently delete your account and associated data.
        </p>
        <Link
          className="zy-button inline-flex min-h-11 cursor-pointer items-center justify-center gap-2 rounded-[14px] px-[17px] py-[11px] text-sm font-semibold disabled:cursor-wait disabled:opacity-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#49a3c9] border border-slate-200 bg-white dark:border-[#363e46] dark:bg-[#23272c] secondary text-red-600"
          to="/delete-account"
        >
          Delete my account
        </Link>
      </section>
    </WorkShell>
  );
}
